// Every PROD article and leder id ends in this segment (census of 17,110 ids, 9 October 2026).
export const JOURNAL_ARTICLE_NUMBER = /^artikkel-\d+$/
